import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Params} from '@angular/router';

@Component({
  selector: 'app-subscriber-create',
  templateUrl: './subscriber-create.component.html',
  styleUrls: ['./subscriber-create.component.scss']
})
export class SubscriberCreateComponent implements OnInit {
  h1: string;
  constructor(private route: ActivatedRoute) { }

  ngOnInit() {
    this.route.params.subscribe((params: Params) => {
      if (params['subscriberId']) {
        this.h1 = 'Editar Suscriptor';
      } else {
        this.h1 = 'Agregar Suscriptor';
      }
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/mailchimp/subscriber/subscriber-create/subscriber-create.component.ts